import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class InscriptionService {

    constructor(){
        this.adresse = new AdresseIP()
        this.adresseIneFaso = new AdresseIP()
    }
    
    /*sendIne(ine) {
        const url = this.adresse.getAdresseIP() +"/service/api/hebergement-cenou/campus-auth/hebergement-etudiant/"
        return axios.get(url+ine)
                    .then(res => res.data);
    }*/
    sendIne(ine) {
        //const url = this.adresseIneFaso.getAdresseIPINEFASO() +"/service/api/inefaso/campus-auth/register?codeIne="
        const url = "https://services.campusfaso.bf/inefaso/service/api/inefaso/campus-auth/register?codeIne="
        return axios.get(url + ine, {
            headers: {
                Authorization: undefined
            }
        }).then(res => res.data);
    }
    create(newInscription) {
        const url = this.adresse.getAdresseIP() +"/service/api/hebergement-cenou/campus-auth/hebergement-etudiant/"
        return axios.post(url,newInscription)
                    .then(res => res.data);
    }

}